export const cacheKeys = {
  getAppointmentRequestMessages: (params) =>
    params
      ? ['getAppointmentRequestMessages', params]
      : ['getAppointmentRequestMessages'],
};
